import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M20.739 7.83228L15.87 3.11926C15.699 2.94837 15.474 3.01133 15.231 3.01133H4.8C3.81 3.01133 3 3.506 3 4.50437V18.8953C3 19.8847 3.81 21 4.8 21H19.2C20.19 21 21 19.8847 21 18.8953V8.4709C21 8.22805 20.901 7.99418 20.739 7.83228ZM19.2 17.9869C19.2 18.4816 18.795 19.1921 18.3 19.1921H5.7C5.205 19.1921 4.8 18.4816 4.8 17.9869V5.3948C4.8 4.90011 5.205 4.8012 5.7 4.8012H13.8V8.0931C13.8 9.08248 14.61 10.1978 15.6 10.1978H19.2V17.9869ZM14.232 13.3638L10.65 15.4145C10.047 15.7563 9.3 15.3246 9.3 14.632V10.5396C9.3 9.84702 10.047 9.4153 10.65 9.75708L14.232 11.8078C14.835 12.1495 14.835 13.022 14.232 13.3638Z' />
        </SvgIcon>
    );
});
